/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignRegeneratePathParams,
	CampaignRegenerateRequest,
	CampaignRegenerateResponse,
} from '../types/CampaignRegenerate'

/**
 * PATCH /campaigns/:campaign/regenerate
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::regenerate
 */
export async function campaignRegenerate(
	campaign: CampaignRegeneratePathParams['campaign'],
	data: CampaignRegenerateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignRegenerateResponse>> {
	return axiosInstance.patch(`/campaigns/${campaign}/regenerate`, data, config)
}
